export class StakeInputParser {
    constructor(decimalSeparators, numberFormat) {
        this.clearInputChecks = decimalSeparators.map(s => {
            var thSeparator = s === "." ? "," : ".";
            return new RegExp(`^([0-9]{1,})?(([0-9]{1,3}(\\${thSeparator}[0-9]{3})*)?\\${s}[0-9]{0,2})?$`);
        });
        let separators = decimalSeparators.join("");
        this.decimalSplitRegExp = new RegExp(`[${separators}](?![0-9]{3}[${separators}])`);
        this.numberFormat = numberFormat;
    }
    parse(value) {
        return parseFloat(this.getClearedNumberValue(value));
    }
    getValueForRedraw(value, deposit) {
        var isCorrectInput = this.clearInputChecks.some(r => value.match(r) !== null);
        if (!isCorrectInput || this.parse(value) !== deposit) {
            return this.numberFormat.format(deposit);
        }
        return value;
    }
    getClearedNumberValue(value) {
        return value && this.convertToStandardNumberString(this.removeExtraLetters(value)) || "0";
    }
    convertToStandardNumberString(value) {
        let decimalSplitMatch = value.match(this.decimalSplitRegExp);
        if (decimalSplitMatch === null) {
            return this.clearIntegerNumberString(value);
        }
        else {
            return this.parseFloatingPointNumberString(decimalSplitMatch[0], value);
        }
    }
    clearIntegerNumberString(value) {
        return value.replace(/[.,]/g, "");
    }
    parseFloatingPointNumberString(separator, result) {
        let index = result.indexOf(separator);
        let leftPart = result.substr(0, index) || "0";
        let rightPart = result.substr(index + 1);
        let thousandSeparator = separator === "." ? /,/g : /\./g;
        return `${leftPart.replace(thousandSeparator, "")}.${rightPart.replace(/[.,]/g, "")}`;
    }
    removeExtraLetters(value) {
        return value.replace(/(?![,.])\D/g, "");
    }
}
//# sourceMappingURL=StakeInputParser.js.map